import { Component, ViewChild } from '@angular/core';
import { EpinService } from '../services/e-pin/epin.service';
import { FilterSearchBarComponent } from '../reusables/filter-search-bar/filter-search-bar.component';
import { Sort } from '@angular/material/sort';
import { GlobalService } from '../global.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-epin-page',
  templateUrl: './epin-page.component.html',
  styleUrls: ['./epin-page.component.css']
})
export class EpinPageComponent {

  @ViewChild(FilterSearchBarComponent) 
  private SearchBar!:FilterSearchBarComponent;
  
  constructor(
    private epinServices: EpinService,
    private globalService: GlobalService,
    private router: Router
  ){}

  isMobile:boolean = false;
  searchValue:string = "";
  current_page:number = 1;
  total_page:number = 1;
  message:string = "";
  isLoading:boolean = false;
  req_parameter:any = {}
  epinListData:Array<any> = [];
  itemsPerPage:number = 15;

  ngOnInit(){
    this.req_parameter.limit = this.itemsPerPage;
    this.getEpins();
  }
  
  async getEpins(){
    this.message = "";
    this.isLoading = true;
    const res = await this.epinServices.getEpins(this.req_parameter);
    if (res) {
      if (res.message) {
        this.message = res.message;
      }else{
        console.log(res)
        this.epinListData = res.items;
        this.total_page = Math.ceil(res.total / this.itemsPerPage);
        
        if (res.total == 0 && res.items.length == 0) {
          this.message = "No item available."
        }
      }
    }
    this.isLoading = false;
    console.log(this.epinListData);
  }
  async exportEpinRecord(){
    this.message = "";
    
    var result = await this.epinServices.exportEpinRecord(this.req_parameter);
            
    if (result) {
      if (result.success) {

        this.globalService.showSnackbar(result.message,"Ok");
        this.router.navigateByUrl("/exports");
      
      }else{
        console.log(result.message);
        this.message = result.message;
      }
    }
  }

  updateSearchValue(data:any){
    this.current_page = 1;
    this.searchValue = data;
    this.req_parameter.search_param = this.searchValue;
    this.getEpins();
  }

  clearAllFilters(){
    this.current_page = 1;
    this.SearchBar.clearSearch();
    this.searchValue = "";
    delete this.req_parameter.search_param;
    this.getEpins();
  }

  updatePage(page_no:number){
    this.current_page = page_no;
    this.req_parameter.offset = page_no * this.itemsPerPage - this.itemsPerPage;
    this.getEpins();
  }
  updateSort(sort:Sort){
    if (sort.direction) {
      this.req_parameter.sort_order = sort.direction;
      this.req_parameter.sort_by = sort.active;
    }else{
      this.req_parameter.sort_order = "";
      this.req_parameter.sort_by = "";
    }
    this.getEpins();
  }

}
